//Mute tooltip content
export const muteTooltipMessage =
  'Videos will be unmuted on scheduled social posts.';
export const muteCaptionDisclaimerMessage =
  'Captions will be turned off and videos will be unmuted on scheduled social posts.';
export const captionTooltip =
  'Captions will be turned off on scheduled social posts.';

export const captionsInPprogressTooltip = 'Captions in progress.';
export const captionsTurnedOnTooltip = 'Captions are turned on.';
export const muteIconTooltip = 'Video is muted.';
export enum CAPTIONS_STATUS_VALUE {
  IN_PROGRESS = 'InProgress',
  SUCCEEDED = 'Succeeded',
  FAILED = 'Failed',
}
